// extracted by mini-css-extract-plugin
module.exports = {"gap":"1rem","desktopGap":"2rem","itemsGrid":"your-data_itemsGrid__uxlKK","item":"your-data_item__4JREw"};